import React from "react";
import {Button} from "../";
import {ChevronLeft, ChevronRight} from "lucide-react";
import {useTranslation} from "react-i18next";
import {Select, SelectTrigger, SelectContent, SelectValue, SelectItem} from "../select";

interface CommonPaginationProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    itemsPerPage?: number;
    onItemsPerPageChange?: (size: number) => void;
    itemsPerPageOptions?: number[];
}

const CommonPagination: React.FC<CommonPaginationProps> = ({
                                                               page,
                                                               totalPages,
                                                               onPageChange,
                                                               itemsPerPage,
                                                               onItemsPerPageChange,
                                                               itemsPerPageOptions = [5, 10, 20, 50, 100],
                                                           }) => {
    const {t} = useTranslation();
    // if (totalPages <= 1) return null;

    // Hiển thị tối đa 5 page, có ellipsis nếu nhiều hơn
    const getPages = () => {
        const pages = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (page <= 3) {
                pages.push(1, 2, 3, 4, 'ellipsis', totalPages);
            } else if (page >= totalPages - 2) {
                pages.push(1, 'ellipsis', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, 'ellipsis', page - 1, page, page + 1, 'ellipsis', totalPages);
            }
        }
        return pages;
    };
    
    if (getPages().length === 0)
        return null;
    
    return (
        <div className="flex flex-col items-center justify-center mt-8 space-y-2">
            <div className="flex items-center space-x-2">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(page - 1)}
                    disabled={page === 1}
                >
                    <ChevronLeft className="h-4 w-4 mr-1"/>
                    {t('ui.previous')}
                </Button>

                {getPages().map((p, idx) =>
                    p === 'ellipsis' ? (
                        <span key={"ellipsis-" + idx} className="px-2 py-1 text-sm text-muted-foreground">
                            {t('ui.ellipsis')}
                        </span>
                    ) : (
                        <Button
                            key={p}
                            variant={p === page ? "default" : "outline"}
                            size="sm"
                            onClick={() => onPageChange(Number(p))}
                        >
                            {p}
                        </Button>
                    )
                )}

                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onPageChange(page + 1)}
                    disabled={page === totalPages}
                >
                    {t('ui.next')}
                    <ChevronRight className="h-4 w-4 ml-1"/>
                </Button>

                {(itemsPerPage !== null && itemsPerPage !== undefined) &&
                    <Select value={itemsPerPage?.toString()}
                            onValueChange={val => onItemsPerPageChange?.(Number(val))}>
                        <SelectTrigger className="h-12">
                            <SelectValue/>
                        </SelectTrigger>
                        <SelectContent>
                            {itemsPerPageOptions.map(option => (
                                <SelectItem className="cursor-pointer" key={option} value={option.toString()}>
                                    {option}/page
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                }
            </div>

        </div>
    );
};

export default CommonPagination;